<template>
<v-app>
  <v-main>
    <v-container class="fill-height elevation-12" fluid>

      <m-globals/>
      
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="6">
          <v-card class="mx-auto mt-5">
            <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{title}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>

              <v-alert 
                v-model="dead_end_alert_visible" 
                type="error"
                color="primary"
                v-if="is_create"
              >
                {{dead_end_alert_message}}<br/><br/>To request a new welcome email <a href="/app/start-reset-password?action=create" style="color: white">click here</a>.
              </v-alert>

              <v-alert 
                v-model="dead_end_alert_visible" 
                type="error"
                color="primary"
                v-else
              >
                {{dead_end_alert_message}}<br/><br/>To request a new password reset <a href="/app/start-reset-password" style="color: white">click here</a>.
              </v-alert>

              <v-form 
                v-if="!dead_end_alert_visible"
              >
                 <v-text-field 
                    v-model="first_name" 
                    prepend-icon="mdi-account" 
                    label="First Name"
                    v-if="is_create"
                  /> 

                   <v-text-field 
                    v-model="last_name" 
                    prepend-icon="mdi-account" 
                    label="Last Name"
                    v-if="is_create"
                  /> 

                <v-text-field 
                  v-model="username" 
                  prepend-icon="mdi-account-circle" 
                  label="Username"
                  ref="username" 
                  disabled
                />

                <v-text-field 
                    v-model="personal_cell" 
                    prepend-icon="mdi-phone" 
                    label="Mobile Number (optional) (recommended)"
                    v-if="is_create"
                    hint="You control when RedChirp will text you"
                  /> 

                <v-text-field
                  v-model="password"
                  prepend-icon="mdi-lock"
                  :label="is_create ? 'Password' : 'New Password'"
                  ref="password"
                  :append-icon="password_append_icon"
                  :type="password_type"
                  v-on:click:append="onTogglePasswordVisible"
                />
                 <v-text-field
                  v-model="confirm_password"
                  prepend-icon="mdi-lock"
                  :label="is_create ? 'Confirm Password' : 'Confirm New Password'"
                  ref="confirm_password"
                  :append-icon="password_append_icon"
                  :type="password_type"
                  v-on:click:append="onTogglePasswordVisible"
                  @keydown.enter="$event.preventDefault(); doResetPassword();"
                />

                <m-sign-in-totp
                  :username="username"
                  :is_valid.sync="is_totp_valid"
                  :totp_setup_qr_code.sync="totp_setup_qr_code"
                  style="margin-left: 35px; margin-bottom: 15px;"
                  v-model="otp"
                />


                <div
                  v-if="is_create"
                >
                  <m-sign-packet
                    agreement_type="accept-above-agreements"
                    :organization_id="organization_id"
                    :meta_data="eula_meta_data"
                    v-model="is_signed"
                  />

                </div>

              </v-form>

              <p
                  style="padding-left: 30px; margin-top: 15px"
                >
                  <a 
                    v-on:click="$rc.contactSupport(is_create ? 'Sign in for the first time (after email)' : 'Reset your password (after email)')"
                  >
                    Need help?  Click here to contact RedChirp support.
                  </a>
                </p>

               <v-alert 
                  v-model="recoverable_alert_visible" 
                  type="error" 
                  dismissible
                  color="primary"
                >
                  {{recoverable_alert_text}} 
                </v-alert>

            </v-card-text>
            <v-card-actions v-if="!dead_end_alert_visible">
              <v-spacer />
              <v-btn color="gray" v-on:click="doCancel" v-if="!is_create">Cancel</v-btn>
              <v-btn 
                color="primary" 
                v-on:click="doResetPassword"
              >
                {{is_create ? 'Setup Account' : 'Reset Password'}}
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-col>
      </v-row>
    </v-container>

  </v-main>
</v-app>
</template>

<script>

  export default {
    data() {
      return {
        reset_request_id: '',
        username: null,
        first_name: null,
        last_name: null,
        personal_cell: null,
        is_signed: false,
        password: '',
        confirm_password: '',

        recoverable_alert_visible: false,
        recoverable_alert_text: null,

        dead_end_alert_message: '',
        dead_end_alert_visible: false,

        password_visible: false,

        password_reset_request: null,
        eula_check: null,
        eula_meta_data: [],
        organization_id: null,

        is_totp_valid: null,
        totp_setup_qr_code: null,
        otp: null,
      }
    },
    mounted () 
    {
      this.$refs.password.focus();
      this.reset_request_id = this.$route.query.request_id;
      this.getRequest();
    },

    methods: 
    {
      getRequest()
      {
        this.$rc.rest({
          'spinner': true,
          'endpoint': 'GET: /api/v1/auth/password-reset-requests/:request_id',
        
          'params' : {
              'request_id': this.reset_request_id,
            },
        
          'on_success': (data) => {
           

              this.organization_id = data.employee_account.organization_id;
              this.username = data.employee_username;
              this.password_reset_request = data.password_reset_request;
              this.first_name = data.first_name;
              this.last_name = data.last_name;
              
              this.personal_cell = this.$rc.pretty(data.personal_cell, 'endpoint_no_parens');

              this.eula_check = data.eula_check;
              this.eula_meta_data = data.eula_meta_data;
            },
        
          'on_error': () => {

            if ( this.is_create )
            {
              // Expired, just take them home...
              this.$router.push({
                'name': 'home',
                'params' : {
                }
              });
            }
            else
            {
              this.dead_end_alert_message = 'Your password reset request has expired.';
            }
            
            this.dead_end_alert_visible = true;
          
          
          },
        });
      },

      doResetPassword() {
       
        if ( this.password !== this.confirm_password )
        {
          this.recoverable_alert_visible = true;
          this.recoverable_alert_text = 'Your passwords do not match.';
          return;
        }

        if ( this.password.length < 6 )
        {
          this.recoverable_alert_visible = true;
          this.recoverable_alert_text = 'Your password must be 6 characters or more';
          return;
        }

        if ( this.is_create )
        {
          if ( this.is_signed != true )
          {
            this.recoverable_alert_visible = true;
            this.recoverable_alert_text = 'You can not finish setting up your account unless you read and accept the agreement';
            return;
          }
        }

        let this_object = this;

        function onSignInOk()
        {
          this_object.onSignInOk()
        }

        function onSignInError(http_status_code)
        {
          this_object.onSignInError(http_status_code)
        }

        this.$rc.rest({
          'spinner': true,
          'endpoint': 'POST: /api/v1/auth/reset-password',
        
          'params' : {
              'reset_request_id': this.reset_request_id,
              'new_password': this.password,

              'first_name': this.first_name,
              'last_name': this.last_name,
              'personal_cell': this.personal_cell,
              'eula_check': this.eula_check,

              'username': this.username,
              'otp': this.otp,
              'totp_setup_qr_code': this.totp_setup_qr_code,
            },
        
          'on_success': (data) => {
              this.$rc.updateProfile(data);
              this.$router.push({name: 'home'});
            },
        
          'on_error': () => {
            this.dead_end_alert_message = 'Unable to reset password.';
            this.dead_end_alert_visible = true;
          },
        });

      },

      
      doCancel()
      {
        this.$router.push({name: 'sign-in', query: {'username' : this.username}});
      },

      onTogglePasswordVisible()
      {
        this.password_visible = !this.password_visible;
      }
    },
    
    computed: {
      password_append_icon(){
        if ( this.password_visible )
          return "mdi-eye-off";
        
        return "mdi-eye";
      },

      password_type(){
        if ( this.password_visible )
          return "text";

        return "password";
      },

      title() {
        if ( this.is_create )
          return 'Setup Your Account';

        return 'Reset Your Password';
      },

      is_create() {
        let cur_url = ''+window.location;
        return cur_url.toLowerCase().includes('setup-account');
      },

      is_valid()
      {
         if ( this.is_create )
         {
            if ( !this.is_signed ) return false;
         }

        return true;
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>